import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from './styles'
import * as outerStyles from '../../styles'

function PasswordComponent({
  id,
  type,
  tabIndex,
  className,
  disabled,
  readOnly,
  value,
  maxLength,
  placeholder,
  onChange,
  onInternalKeyDown,
  onBlur,
  onTriggerType,
  ...params
}) {
  return (
    <>
      <input
        id={id}
        tabIndex={tabIndex}
        type={type}
        css={[outerStyles.input(params), styles.password]}
        className={className}
        readOnly={readOnly}
        autoComplete="new-password"
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onInternalKeyDown}
      />
      {disabled || readOnly ? null : (
        <Button
          plain
          tabIndex={-1}
          title={type === 'text' ? 'Hide password' : 'Show password'}
          css={styles.revealButton}
          onClick={onTriggerType}
        >
          <FontAwesomeIcon
            size="lg"
            color="white"
            icon={type === 'text' ? 'eye-slash' : 'eye'}
          />
        </Button>
      )}
    </>
  )
}

PasswordComponent.propTypes = {
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onInternalKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.oneOf(['password', 'text']).isRequired,
  onTriggerType: PropTypes.func.isRequired,
}

export default PasswordComponent
